import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sim-side-panel',
  standalone: true,
  templateUrl: './side-panel.component.html',
  styleUrl: './side-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimSidePanelComponent {}
